module.exports = __webpack_public_path__ + "img/add_photo.271ca9e0.svg";